import { Component, OnInit } from '@angular/core';
import { AdService } from '@lib-modules/ads/services/ad.service';
import {HomeNewsTabService} from '@modules/home/tabs/news/services/home-news-tab.service';

@Component({
  selector: 'app-news-page',
  templateUrl: './news-page.component.html',
  styleUrls: ['./news-page.component.scss'],
})
export class NewsPageComponent implements OnInit {

  constructor(
    public homeNewsTabService: HomeNewsTabService,
    private adService: AdService,
  ) { }

  public async ngOnInit() {
    await this.homeNewsTabService.loadPaginatedNews(true);
  }

  onLoadMore() {
    this.adService.refreshSidebarAds();
    this.homeNewsTabService.loadPaginatedNews();
  }
}
